import { DatasetStatus, PendingStatus } from '../../components/dataset/types'

// For color names - https://www.color-name.com/hex
export const colors = {
  brand: {
    primary: '#30505A',
  },
  white: '#FFFFFF',
  black: '#000000',
  blue: {
    main: '#0091FF',
    light: '#53B5FF',
    dark: '#057BD4',
    hover: '#0064CB',
    smokey: '#30505A',
    smokey_light: '#4A666E',
    smokey_lighter: '#788B90',
    aliceBlue: '#f0f9ff',
  },
  gray: {
    main: '#D8D8D8',
    medium: '#777777',
    light: '#FAFAFA',
    dark: '#2E3C3E',
    blue: '#B1BDC0',
    gray200: '#eee',
  },
  green: {
    main: '#01A166',
    light: '#18D486',
    dark: '#147853',
    darkText: '#1E4620',
    blue: '#499A7F',
    lime: '#9AD187',
    yellow: '#C3D078',
  },
  orange: {
    main: '#FF7E00',
    light: '#FF8F00',
    dark: '#EC7032',
  },
  peach: {
    main: '#F7715D',
  },
  pink: {
    main: '#FC5F80',
    dark: '#C75275',
  },
  purple: {
    main: '#6236FF',
    dark: '#464673',
  },
  red: {
    main: '#FF0000',
    light: '#FF5151',
    dark: '#E31A0D',
    darker: '#621B16',
    orange: '#FF5700',
  },
  teal: {
    main: '#80C6A9',
    light: '#5BEEAF',
    darker: '#1c2c2e',
  },
  yellow: {
    main: '#FFC13C',
    light: '#EDCF69',
    warning: '#ff9800',
  },
  lotion: '#FAFAFA',
  ghostWhite: '#F9F9F9',
  antiFlashWhite: '#F0F0F0',
  chineseYellow: '#FFB000',
  davysGray: '#555555',
  sonicSilver: '#757575',
} as const

export const patternTypeColors = {
  autonumber: colors.green.main,
  constant: colors.blue.smokey,
  date: colors.purple.main,
  random: colors.orange.dark,
  variable: colors.blue.main,
} as const

export const alertColors = {
  error: colors.red.light,
  info: colors.blue.main,
  success: colors.green.main,
  warning: colors.orange.light,
} as const

export const submissionStatusColors = {
  [DatasetStatus.WARNING]: colors.yellow.main,
  [DatasetStatus.COMPLETE]: colors.green.main,
  [PendingStatus.DRAFT]: colors.green.main,
  [DatasetStatus.APPROVED]: colors.blue.main,
  [PendingStatus.AWAITING_APPROVAL]: colors.blue.main,
  [DatasetStatus.PENDING]: colors.blue.main,
  [PendingStatus.PAUSED]: colors.purple.main,
  [PendingStatus.SHARED_DRAFT]: colors.purple.main,
  [PendingStatus.ERROR]: colors.red.main,
  [PendingStatus.REJECTED]: colors.red.main,
  [PendingStatus.FAILED_VALIDATION]: colors.red.main,
} as const
